import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, LogOut } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../lib/AuthContext';

// Minimal shell for the platform admin console (/admin)
export const AdminShell = ({ children, title = 'Platform admin' }) => {
  const { logout, config } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-dvh bg-[hsl(var(--background))]">
      <header className="sticky top-0 z-40 bg-[hsl(var(--foreground))] text-white">
        <div className="max-w-6xl mx-auto px-4 md:px-6 h-14 flex items-center justify-between">
          <button data-testid="admin-home-link" onClick={() => navigate('/admin')} className="flex items-center gap-2 font-display font-semibold">
            <ShieldCheck className="h-5 w-5 text-teal-300" />
            {config?.app_name || 'Auto Pampanga'} — {title}
          </button>
          <Button data-testid="admin-logout-button" variant="ghost" size="sm" className="text-white hover:bg-white/10 rounded-xl" onClick={() => { logout(); navigate('/login'); }}>
            <LogOut className="h-4 w-4 mr-1.5" /> Log out
          </Button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-5 md:px-6 space-y-5">{children}</main>
    </div>
  );
};
